import React, { ReactNode } from 'react';
import classNames from 'classnames';

import { SearchIcon } from '../../../../svgs/icons/generics';

import styles from './SearchInputStyle.module.css';

interface SearchInputStyleProps {
  dataHcName?: string;
  dataHcEventSection?: string;
  className?: string;
  children: ReactNode;
  icon?: ReactNode | null;
  unstyled?: boolean;
}
export const SearchInputStyle = ({
  dataHcName,
  dataHcEventSection,
  children,
  className,
  icon,
  unstyled = false,
}: SearchInputStyleProps) => {
  let effectiveIcon = icon;
  if (typeof effectiveIcon === 'undefined') {
    effectiveIcon = <SearchIcon dataHcName={'search-icon'} size="sm" />;
  }
  return (
    <div
      data-hc-name={dataHcName}
      data-hc-event-section={dataHcEventSection}
      className={classNames(
        styles.SearchInputStyle,
        {
          [styles.unstyled]: unstyled,
        },
        className,
      )}
    >
      {effectiveIcon}
      {children}
    </div>
  );
};
